
angular.module('bmsApp.training').factory('TrainingProviderSvc', function (CRUDSvc, TRAINING_PROVIDER_API) {

	return {
		create: function (trainingProvider) {
			return CRUDSvc.post(TRAINING_PROVIDER_API.CREATE, trainingProvider);
		},
		update: function (id, trainingProvider) {
			return CRUDSvc.post(TRAINING_PROVIDER_API.UPDATE + id, trainingProvider);
		},
		delete: function (id) {
			return CRUDSvc.get(TRAINING_PROVIDER_API.DELETE + id);
		},
		options: function () {
			return CRUDSvc.get(TRAINING_PROVIDER_API.OPTIONS);
		}
	};

}).constant('TRAINING_PROVIDER_API', {
	CREATE: 'api/trainingProvider/create',
	UPDATE: 'api/trainingProvider/update/',
	DELETE: 'api/trainingProvider/delete/',
	OPTIONS: 'api/trainingProvider/options'
});
